import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import * as actions from '../actions/dashboard';
// import { SUCCESS, START, ERROR } from '../actions/global';

const initialStats = {
  dashboards: { data: [], state: null },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 1000,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  selectedDashboardTitle: '',
  selectedDashboardYear: '2023',
  selectedDashboardStartDt: null,
  selectedDashboardEndDt: null,
  selectedQueryTitle: '',
  selectedQueryYear: '2023',
  selectedQueryStartDt: null,
  selectedQueryEndDt: null,
  selectedQueryID: '',
  selectedQueryString: '',
  selectedViewMode: 'worktype',
  dashboardList: [],
  queryResults: { data: [], state: null },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.FETCH_DASHBOARDS_ROLE_START: {
      return state
        .setIn(['dashboards', 'data'], fromJS({}))
        .setIn(['dashboards', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_DASHBOARDS_ROLE_SUCCESS: {
      return state
        .setIn(['dashboards', 'state'], fetchingState.LOADED)
        .setIn(
          ['dashboards', 'data'],
          fromJS(_.get(action, 'data.results', {})),
        );
    }
    case actions.FETCH_DASHBOARDS_ROLE_ERROR: {
      return state.setIn(['dashboards', 'state'], fetchingState.ERROR);
    }

    case actions.SET_SELECTED_DASHBOARD_TITLE: {
      return state.setIn(['selectedDashboardTitle'], action.payload);
    }
    case actions.SET_SELECTED_DASHBOARD_YEAR: {
      return state.setIn(['selectedDashboardYear'], action.payload);
    }
    case actions.SET_SELECTED_DASHBOARD_STARTDT: {
      return state.setIn(['selectedDashboardStartDt'], action.payload);
    }
    case actions.SET_SELECTED_DASHBOARD_ENDDT: {
      return state.setIn(['selectedDashboardEndDt'], action.payload);
    }
    case actions.SET_SELECTED_QUERY_TITLE: {
      return state.setIn(['selectedQueryTitle'], action.payload);
    }
    case actions.SET_SELECTED_QUERY_YEAR: {
      return state.setIn(['selectedQueryYear'], action.payload);
    }
    case actions.SET_SELECTED_QUERY_STARTDT: {
      return state.setIn(['selectedQueryStartDt'], action.payload);
    }
    case actions.SET_SELECTED_QUERY_ENDDT: {
      return state.setIn(['selectedQueryEndDt'], action.payload);
    }
    case actions.SET_SELECTED_QUERY_STRING: {
      return state.setIn(['selectedQueryString'], action.payload);
    }
    case actions.SET_SELECTED_QUERY_ID: {
      return state.setIn(['selectedQueryID'], action.payload);
    }
    case actions.SET_SELECTED_VIEW_MODE: {
      return state.setIn(['selectedViewMode'], action.payload);
    }
    case actions.SET_DASHBOARD_LIST: {
      return state.setIn(['dashboardList'], fromJS(action.payload));
    }
    default: {
      return state;
    }
  }
};
